// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GuShmlgQU24O2r {
  display: flex;
  position: fixed;
  z-index: 1;
  right: var(--ds-space-0, 0px);
  left: var(--ds-space-0, 0px);
  align-items: flex-end;
  justify-content: center;
  height: 0;
  gap: var(--ds-space-100, 8px);
  pointer-events: none;
}
.E5Al1WuMnZSnCa {
  display: flex;
  padding: var(--ds-space-075, 6px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  gap: var(--ds-space-075, 6px);
  pointer-events: auto;
}
html[data-color-mode='dark'] .E5Al1WuMnZSnCa {
  background-color: var(--ds-surface-sunken, #f7f8f9);
}
.bbfk8j2Kk_Eoy5 .E5Al1WuMnZSnCa {
  box-sizing: border-box;
  flex: 1;
  align-items: center;
  height: 100%;
  padding: var(--ds-space-100, 8px);
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.bbfk8j2Kk_Eoy5 .E5Al1WuMnZSnCa > div {
  flex: 2 0;
}
@media print {
  .GuShmlgQU24O2r {
    display: none;
  }
}
`, ""]);
// Exports
export var islandNav = `GuShmlgQU24O2r`;
export var buttonGroup = `E5Al1WuMnZSnCa`;
export var fullWidth = `bbfk8j2Kk_Eoy5`;
export default ___CSS_LOADER_EXPORT___;
